<!-- @veltra/icons generated sha256:3249f79960d03a8e gen:8 source:src/svg/normal/pin-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'PinFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12.518 1.34a.6.6 0 0 0-.811-.035l-3.7 3.122a.5.5 0 0 1-.673-.036l-.443-.443a.6.6 0 0 0-.849 0L3.937 6.052a.6.6 0 0 0 0 .849l1.867 1.867a.506.506 0 0 1 .01.712l-3.406 3.405a.5.5 0 0 0 .708.707c.776-.776 2.628-2.63 3.405-3.405a.506.506 0 0 1 .712.009l1.866 1.867a.6.6 0 0 0 .849 0l2.104-2.105a.6.6 0 0 0 0-.849l-.443-.443a.5.5 0 0 1-.036-.674l3.122-3.699a.6.6 0 0 0-.034-.81z"
    />
  </svg>
</template>
